import { makeStyles } from "@material-ui/core";

export const HeaderStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    boxShadow:
      "0px 5px 16px 0px rgba(0,0,0,0.03), 0px 5px 16px 0px rgba(0,0,0,0.03), 0px 5px 16px 0px rgba(0,0,0,0.03)",
  },
  logo: {
    maxWidth: 170,
  },
}));
